import { createStyles, FormControl, FormControlLabel, Radio, RadioGroup, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

import { colorPalette, textSizes, TextSizesEnum } from '../../../theme';
import { EnumData } from '../../../utils/enumData';

export interface PlexRadioGroupProps<T extends string | boolean> {
  className?: string;
  handleChange: (value: T) => void;
  options: EnumData<T>;
  value: T | null | undefined;
  name: string;
}

export function PlexRadioGroup<T extends string | boolean>({
  handleChange,
  name,
  value,
  options,
}: PlexRadioGroupProps<T>): React.ReactElement {
  const classes = useStyles();
  const allOptions = Object.keys(options);
  const selectedValueList = allOptions.filter((item) => options[item].value === value);
  const selectedValue = selectedValueList.length === 1 ? selectedValueList[0] : '';

  return (
    <FormControl className={classes.radioGroup}>
      <RadioGroup
        aria-label={name}
        name={name}
        value={selectedValue}
        onChange={(event: React.ChangeEvent<{ name?: string; value: unknown }>): void => {
          const value = allOptions.filter((item) => item === event.target.value)[0];
          const v: T = options[value].value;
          handleChange(v);
        }}
      >
        {allOptions.map((item: string) => (
          <FormControlLabel
            key={item}
            classes={{ root: classes.labelRoot, label: classes.label }}
            value={item}
            control={<Radio color={'primary'} />}
            label={options[item].displayName}
            className={classes.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radioGroup: {
      width: '100%',
    },
    labelRoot: {
      paddingLeft: 37,
      borderBottom: `1px solid ${colorPalette.gray._300}`,
      height: 75,
      margin: 0,
    },
    label: {
      ...textSizes[TextSizesEnum.NormalPlus],
      fontWeight: 500,
    },
  })
);
